import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { formatDateRange } from "@/lib/format";

const makeIcon = (promoted) =>
  L.divIcon({
    className: "",
    html: `<div class="pagan-marker ${promoted ? "promoted" : ""}"></div>`,
    iconSize: [22, 22],
    iconAnchor: [11, 22],
    popupAnchor: [0, -20],
  });

function FitBounds({ events }) {
  const map = useMap();
  useEffect(() => {
    if (events.length > 0) {
      const bounds = L.latLngBounds(events.map((e) => [e.lat, e.lng]));
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 9 });
    }
  }, [events, map]);
  return null;
}

export const EventMap = ({ events, height = "520px" }) => {
  const { lang, tCategory } = useLang();
  const navigate = useNavigate();

  return (
    <div className="rounded-xl overflow-hidden border border-[#272A34] shadow-[0_10px_30px_rgba(0,0,0,0.8)]" style={{ height }} data-testid="event-map">
      <MapContainer center={[46.8182, 8.2275]} zoom={8} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          className="dark-tiles"
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        <FitBounds events={events} />
        {events.map((e) => (
          <Marker key={e.slug} position={[e.lat, e.lng]} icon={makeIcon(e.promoted)}>
            <Popup>
              <div className="min-w-[180px]">
                <div className="text-[10px] font-mono uppercase tracking-wider text-amber-500 mb-1">{tCategory(e.category)}</div>
                <div className="font-serif text-sm text-stone-100 mb-1 leading-snug">{e.title}</div>
                <div className="text-xs text-stone-400 mb-2">{e.city} · {formatDateRange(e.start_date, e.end_date, lang)}</div>
                <button
                  data-testid={`map-popup-link-${e.slug}`}
                  onClick={() => navigate(`/events/${e.slug}`)}
                  className="text-xs font-semibold text-amber-400 hover:text-amber-300 underline"
                >
                  →
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default EventMap;
